import { Trans, useTranslation } from 'react-i18next'

import {
  Button,
  ButtonColor,
  ButtonVariant,
  DeleteModal,
  JustifyVariant,
  Modal,
  SimpleInput,
} from '@makyoapp/makyo-ui/'

import useAccountManagement from '../hooks/useAccountManagement'

function AccountManagementPanel() {
  const { t } = useTranslation()
  const {
    showDelete,
    delValue,
    handleDeleteAccount,
    isDelLoading,
    setShowDelete,
    setDelValue,
    showInfoModal,
    handleHideInfo,
  } = useAccountManagement()

  return (
    <>
      <div className='pb-8'>
        {/* Download information button */}
        <Button id='download-info-btn' className='w-40' variant={ButtonVariant.Outlined}>
          {t('Download my info')}
        </Button>
      </div>
      <div className='pb-8'>
        {/* Delete account button */}
        <Button
          id='delete-account-btn'
          className='w-40'
          colorStyle={ButtonColor.Danger}
          onClick={() => setShowDelete(true)}
        >
          {t('Delete Account')}
        </Button>
        {/* Delete account modal - triggered when delete account button is clicked */}
        <DeleteModal
          id='my-profile-delete-modal'
          show={showDelete}
          onHide={() => {
            setShowDelete(false)
            setDelValue('')
          }}
          onSubmit={handleDeleteAccount}
          isLoading={isDelLoading}
          title={t('Delete Account')}
          continueLabel={t('Yes, delete')}
          withCancel
          canContinue={delValue === 'DELETE'}
        >
          <div className='modal-md leading-[2]'>
            {/* Modal content */}
            <div className='font-bold text-base mb-8'>{t('Are you sure you want to delete your account?')}</div>
            <div className='mb-8'>
              <Trans i18nKey='deleteAccountNotice1'>
                After submitting this form, you have <strong>14 days</strong> to log back into your account to restore
                it before it’s <strong>permanently deleted</strong>.
              </Trans>
            </div>
            <div>{t('The following will be deleted as well:')}</div>
            <div className='mb-8'>
              <ul>
                <li className='list-disc list-inside font-bold'>
                  {t('All created apps, databases Organizations and teams that you created')}
                </li>
                <li className='list-disc list-inside font-bold'>{t('All uploaded media')}</li>
              </ul>
            </div>
          </div>
          <div className='mb-4'>{t('Type "DELETE" below if you want to proceed:')}</div>
          {/* Input for delete account confirmation */}
          <SimpleInput id='del-account' value={delValue} onChange={(e) => setDelValue(e.currentTarget.value)} />
        </DeleteModal>
        {/* Conditional rendering of the information modal, showing after account delete confirmation */}
        {showInfoModal && (
          <Modal show={true} onHide={handleHideInfo}>
            {/* Modal Header */}
            <Modal.Header onCloseClick={handleHideInfo}>{t('Account deleted')}</Modal.Header>
            {/* Modal Body */}
            <Modal.Body>
              <div className='modal-md'>
                <div className='text-sm mb-2'>{t('Your account has been deleted.')}</div>
                <div className='text-light'>
                  {t(
                    'It can be restored within 14 days if you wish. Log in and follow the steps to restore your account.'
                  )}
                </div>
              </div>
            </Modal.Body>
            {/* Modal Footer */}
            <Modal.Footer justify={JustifyVariant.End}>
              <Button onClick={handleHideInfo}>{t('Ok')}</Button>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    </>
  )
}

export default AccountManagementPanel
